import createReactComponent from '../createReactComponent';
var Gavel = createReactComponent('Gavel', [['path', {
  d: 'M14 13l-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 010-3L11 10',
  key: 'zarn80'
}], ['path', {
  d: 'M16 16l6-6',
  key: 'q4dzh2'
}], ['path', {
  d: 'M8 8l6-6',
  key: '1anfot'
}], ['path', {
  d: 'M9 7l8 8',
  key: '143twj'
}], ['path', {
  d: 'M21 11l-8-8',
  key: '1vcrla'
}]]);
export default Gavel;